export default function ErrorMessage(){
  return {
    restrict: "E",
    scope:{
      worker: "="
    },
    template: require("./ErrorMessage.html")
  }
}


// WEBPACK FOOTER //
// ./src/util/ErrorMessage.js